import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  OnDestroy,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { PlatformService } from '@panamax/app-state';
import { ReportStoredProcedure } from '@usf/ngrx-customer-reporting';

@Component({
  selector: 'app-csv-download-card',
  templateUrl: './csv-download-card.component.html',
  styleUrls: ['./csv-download-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CsvDownloadCardComponent implements OnChanges, OnDestroy {
  @Input() storedProcedure: ReportStoredProcedure;
  @Input() buttonLabel: string;
  @Input() disabledState: any;
  @Input() loadingState: any;
  @Output() handleReport = new EventEmitter<ReportStoredProcedure>();
  @Input() isTableViewActive = false;

  loading = false;
  showTimeMessage = false;
  disabled = false;
  private timeoutId: any = null;

  constructor(
    public platformService: PlatformService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    const procedureToStateMap = {
      SP_QUERY_SALES_DETAIL_DATA: 'detailData',
      SP_QUERY_PRODUCT_DETAIL_DATA: 'productDetailData',
      SP_QUERY_INVOICE_HISTORY_DATA: 'invoiceHistoryData',
    };

    const stateKey = procedureToStateMap[this.storedProcedure];
    if (stateKey && this.disabledState) {
      this.disabled = this.disabledState[stateKey];
    }

    if (stateKey && this.loadingState) {
      const isCurrentlyLoading = this.loadingState[stateKey];

      if (this.loading !== isCurrentlyLoading) {
        this.loading = isCurrentlyLoading;

        if (this.loading) {
          this.clearTimeout();

          this.timeoutId = setTimeout(() => {
            this.showTimeMessage = true;
            this.cdr.markForCheck();
          }, 10000);
        } else {
          this.showTimeMessage = false;
          this.clearTimeout();
        }

        this.cdr.detectChanges();
      }
    }
  }

  private clearTimeout(): void {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  }

  ngOnDestroy(): void {
    this.clearTimeout();
  }

  emitDownload() {
    this.handleReport.emit(this.storedProcedure);
  }
}
